// Regulatory Capital: the route and the sidebar row of
// `wealth.compliance.reg-capital` (ADR-0027).
//
// The page is an empty state: no source writes the capital figures yet.
// Dowgate staff see it today, so the Dowgate manifest turns the feature on.
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.reg-capital',
    routes: [
        {
            frontend: 'comply',
            path: 'reg-capital',
            lazy: () => import('@/pages/comply/reg-capital/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'reg-capital',
            label: 'Regulatory Capital',
            href: '/comply/reg-capital',
            icon: 'Landmark',
            group: 'governance',
            order: 1210,
            wip: true,
        },
    ],
});
